import splitTime from "./SplitTime";

export default function parseHours(rawHours) {
	const hours = rawHours.replace(" [H]", "");
	const parsed = splitTime(hours);
	return `${hours}h (${parsed.Days} days)`;
}
